// @ts-nocheck
import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import { inject, observer } from 'mobx-react'
import Title from 'components/common/Title'
import MenuItem from './MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import { StoreContext } from '../../contexts/StoreContext'

const useStyles = makeStyles({
	fakeRowForScrolling: {
		height: '48px',
	},
	grid: {
		/*		paddingTop: '10px',
		paddingLeft: '10px',
		paddingRight: '10px', */
		padding: '10px',
	},
	item: {
		padding: '8px',
	},
})

const SearchResults = inject()(
	observer((props) => {
		const { store } = useContext(StoreContext)
		const { items } = store.data

		const classes = useStyles()

		return (
			<Grid container className={classes.grid} spacing={0}>
				<Grid item xs={12}>
					<Title variant="h3" title="Search Results" />
				</Grid>

				{props.results.map((itemId, index) => (
					<Grid item xs={6} sm={4} md={3} lg={2} key={itemId} className={classes.item}>
						<MenuItem {...items[itemId]} index={index} />
					</Grid>
				))}
			</Grid>
		)
	})
)

export default SearchResults
